// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"bb4f6b48","121":"aec92cd1","163":"7cbcbfda","251":"21917af0","328":"b948b44d","420":"2e4707ff","460":"c88ed55a","606":"46c69229","693":"e3557d08","767":"77d58cfb","795":"279fefcd","848":"e8bd5cf9","916":"6414f961"}[chunkId] + ".chunk.js";
};